import { useQuery } from "@apollo/client";

import { CHECK_BITBUCKET_CLOUD_HAS_DEFAULT_INTEGRATION } from "./gql";

const useCheckBitbucketCloudHasDefaultIntegration = (skip: boolean) => {
  const { data, loading } = useQuery(CHECK_BITBUCKET_CLOUD_HAS_DEFAULT_INTEGRATION, {
    fetchPolicy: "no-cache",
    skip,
  });

  return {
    hasDefaultIntegration:
      typeof data?.checkBitbucketCloudHasDefaultIntegration?.id !== "undefined",
    loading,
  };
};

export default useCheckBitbucketCloudHasDefaultIntegration;
